import axios from "axios";

const SERVER = process.env.REACT_APP_SERVER_DOMAIN || "http://localhost:8000";

/** GET /api/accounts/onboard-step — current account's Onboard-checklist progress (0-3). */
export async function fetchOnboardStep(token) {
  const response = await axios.get(`${SERVER}/api/accounts/onboard-step`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data?.onboardStep ?? 0;
}

/** PATCH /api/accounts/onboard-step — advance the account's Onboard-checklist progress. */
export async function updateOnboardStep(step, token) {
  const response = await axios.patch(
    `${SERVER}/api/accounts/onboard-step`,
    { step },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data?.onboardStep ?? step;
}
